import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface RepresentativeFirstNameProps {
    required?: boolean;
    onValidationEvent: (isValid: boolean) => void;
}

export const RepresentativeFirstName: React.FC<RepresentativeFirstNameProps> = ({ required = false, onValidationEvent }) => {
    const isMobile = isMobileScreen();
    const label = 'First Name';
    const value = useBrokerNewReferralStore((s) => s.referral.repFirstName);
    const setValue = useBrokerNewReferralStore((s) => s.set_repFirstName);

    return (
        <>
            <TextBox
                id='representativeFirstNameTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : '200px'}
                onValidationEvent={onValidationEvent}
            />
        </>
    );
};
